import { api } from '../../api-helper';
import { URLS } from '../../../constants/URLS';

export const getClientMapDetails = (params = {}) => {
  return api.get(URLS.getClientMap, {
    params,
    headers: {
      needsToken: true
    }
  });
};

export const clientMapSearch = (searchQuery) => {
  return api.get(URLS.clientMapSearch, {
    params: {
      query: searchQuery
    },
    headers: {
      needsToken: true
    }
  });
};

export const getMapSearchResultsList = (
  query = '',
  assetIds = [],
  limit = 25,
  page = 1,
  data = null
) => {
  return api.post(
    URLS.clientMapSearchList,
    {
      query: query,
      assetIds: assetIds,
      limit: limit,
      page: page,
      ...(data && { data: data })
    },
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const getMapBookmarkSearch = (
  query = '',
  limit = 5,
  orderIds = null,
  addresses = null,
  all = false
) => {
  return api.post(
    URLS.bookmarkSearch,
    {
      limit,
      query,
      ...(orderIds && { orderIds }),
      ...(addresses && { addresses }),
      ...(all && { all: true })
    },
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const bookmarkMapItem = (id, bookmarkData) => {
  return api.put(URLS.bookmarkMap, bookmarkData, {
    params: {
      id
    },
    headers: {
      needsToken: true
    }
  });
};

export const deleteBookmarkMapItem = (listId, elementDetails) => {
  return api.delete(URLS.bookmarkMapElement, {
    data: {
      ...(listId && { id: listId }),
      ...elementDetails
    },
    headers: {
      needsToken: true
    }
  });
};

export const bookmarkMapElementNewList = (elementDetails) => {
  return api.post(URLS.bookmarkMap, elementDetails, {
    headers: {
      needsToken: true
    }
  });
};

export const getMapBookmarkList = (listId) => {
  return api.post(
    URLS.bookmarkMap,
    {
      id: listId
    },
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const deleteMapBookmarkList = (listId) => {
  return api.delete(URLS.bookmarkMap, {
    params: {
      id: listId
    },
    headers: {
      needsToken: true
    }
  });
};

export const handleChangeMapBookmarkListName = (listId, listName) => {
  return api.put(
    URLS.bookmarkMap,
    {
      name: listName
    },
    {
      params: {
        id: listId
      },
      headers: {
        needsToken: true
      }
    }
  );
};

export const getBookmarkMapElementsList = (filterData) => {
  return api.post(URLS.bookmarkMapElement, filterData, {
    headers: {
      needsToken: true
    }
  });
};

export const mapWindowInfo = (elementId) => {
  return api.get(URLS.mapWindowInfo, {
    params: {
      id: elementId
    },
    headers: {
      needsToken: true
    }
  });
};

export const updateSiteCoords = (updateData) => {
  return api.post(URLS.updateSiteCoords, updateData, {
    headers: {
      needsToken: true
    }
  });
};

export const getMapPinInfo = (orderID) => {
  return api.get(URLS.mapPinInfo, {
    params: {
      id: orderID
    },
    headers: {
      needsToken: true
    }
  });
};

export const getSitePropertyDetails = (siteDetails) => {
  return api.post(URLS.getSitePropertyDetails, siteDetails, {
    headers: {
      needsToken: true
    }
  });
};
